import {
    useEffect,
    useState
} from "react";

import {
    Link
} from "react-router-dom";

import {
    FaShieldAlt
} from "react-icons/fa";

import API from "../../services/api";

import {
    FaPlus,
    FaEdit,
    FaTrash,
    FaSearch,
    FaUserShield
} from "react-icons/fa";

import Swal from "sweetalert2";
import { hasPermission } from "../../utils/permission";

function Roles() {

    const [roles, setRoles] =
        useState([]);

    const [search, setSearch] =
        useState("");

    const [page, setPage] =
        useState(1);

    const [pages, setPages] =
        useState(1);

    const [loading, setLoading] =
        useState(false);

    useEffect(() => {
        loadRoles();
    }, [page, search]);

    const loadRoles =
        async () => {

            try {

                setLoading(true);

                const res =
                    await API.get(
                        `/roles?page=${page}&search=${search}`
                    );

                setRoles(
                    res.data.roles
                );

                setPages(
                    res.data.pages
                );

            } catch (err) {

                console.log(err);

            } finally {

                setLoading(false);

            }

        };

    const deleteRole =
        async (id) => {

            const confirm =
                await Swal.fire({
                    title:
                        "Delete Role?",
                    text:
                        "This action cannot be undone.",
                    icon:
                        "warning",
                    showCancelButton:
                        true,
                    confirmButtonColor:
                        "#facc15"
                });

            if (!confirm.isConfirmed)
                return;

            try {

                await API.delete(
                    `/roles/${id}`
                );

                loadRoles();

            } catch (err) {

                console.log(err);

            }

        };

    return (

        <div>

            <div
                className="
        flex
        justify-between
        items-center
        mb-6
      "
            >

                <div>

                    <h1
                        className="
            text-4xl
            font-bold
          "
                    >
                        Roles
                    </h1>

                    <p
                        className="
            text-gray-400
            mt-2
          "
                    >
                        Manage Roles
                    </p>

                </div>

                {hasPermission("role.add") && (
                    <Link
                        to="/admin/roles/add"
                        className="
          flex
          items-center
          gap-2
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
        "
                    >
                        <FaPlus />
                        Add Role
                    </Link>
                )}

            </div>

            <div
                className="
        bg-[#111]
        rounded-2xl
        p-5
      "
            >

                <div
                    className="
          relative
          mb-5
        "
                >

                    <FaSearch
                        className="
            absolute
            left-4
            top-4
            text-gray-400
          "
                    />

                    <input
                        value={search}
                        onChange={(e) => {
                            setSearch(
                                e.target.value
                            );

                            setPage(1);

                        }
                        }
                        placeholder="Search role..."
                        className="
            w-full
            pl-11
            pr-4
            py-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
          "
                    />

                </div>

                <div
                    className="
          overflow-x-auto
        "
                >

                    <table
                        className="
            w-full
          "
                    >

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
              "
                            >

                                <th className="py-3 text-left">
                                    #
                                </th>

                                <th className="py-3 text-left">
                                    Role
                                </th>

                                <th className="py-3 text-left">
                                    Description
                                </th>

                                <th className="py-3 text-left">
                                    Status
                                </th>

                                <th className="py-3 text-left">
                                    Created
                                </th>

                                <th className="py-3 text-center">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="
                      py-8
                      text-center
                    "
                                        >
                                            Loading...
                                        </td>

                                    </tr>

                                    :

                                    roles.length === 0 ?

                                        <tr>

                                            <td
                                                colSpan="6"
                                                className="
                        py-10
                        text-center
                        text-gray-500
                      "
                                            >

                                                <FaUserShield
                                                    size={45}
                                                    className="
                          mx-auto
                          mb-3
                        "
                                                />

                                                No Roles Found

                                            </td>

                                        </tr>

                                        :

                                        roles.map(
                                            (
                                                role,
                                                index
                                            ) => (

                                                <tr
                                                    key={role.id}
                                                    className="
                          border-b
                          border-white/5
                          hover:bg-black/30
                        "
                                                >

                                                    <td
                                                        className="
                            py-4
                          "
                                                    >
                                                        {
                                                            (
                                                                page - 1
                                                            ) *
                                                            10 +
                                                            index +
                                                            1
                                                        }
                                                    </td>

                                                    <td
                                                        className="
                            py-4
                            font-semibold
                          "
                                                    >
                                                        {
                                                            role.role_name
                                                        }
                                                    </td>

                                                    <td
                                                        className="
                            py-4
                            text-gray-400
                          "
                                                    >
                                                        {
                                                            role.description
                                                        }
                                                    </td>

                                                    <td
                                                        className="
                            py-4
                          "
                                                    >

                                                        <span
                                                            className={`
                              px-3
                              py-1
                              rounded-full
                              text-sm

                              ${role.status ===
                                                                    "active"
                                                                    ?
                                                                    "bg-green-500/20 text-green-400"
                                                                    :
                                                                    "bg-red-500/20 text-red-400"
                                                                }
                            `}
                                                        >

                                                            {
                                                                role.status
                                                            }

                                                        </span>

                                                    </td>

                                                    <td
                                                        className="
                            py-4
                          "
                                                    >
                                                        {
                                                            new Date(
                                                                role.created_at
                                                            )
                                                                .toLocaleDateString()
                                                        }
                                                    </td>

                                                    <td
                                                        className="
                            py-4
                            text-center
                          "
                                                    >

                                                        <div
                                                            className="
                              flex
                              justify-center
                              gap-3
                            "
                                                        >

                                                            <div className="flex justify-center gap-4">
                                                                {hasPermission("role.edit") && (
                                                                    <Link
                                                                        to={`/admin/roles/edit/${role.id}`}
                                                                        className="text-yellow-400"
                                                                    >
                                                                        <FaEdit />
                                                                    </Link>
                                                                )}

                                                                {hasPermission("role.permission") && (
                                                                    <Link
                                                                        to={`/admin/roles/permissions/${role.id}`}
                                                                        className="text-blue-400"
                                                                    >
                                                                        <FaShieldAlt />
                                                                    </Link>
                                                                )}

                                                                {hasPermission("role.delete") && (
                                                                    <button
                                                                        onClick={() => deleteRole(role.id)}
                                                                        className="text-red-500"
                                                                    >
                                                                        <FaTrash />
                                                                    </button>
                                                                )}

                                                            </div>

                                                        </div>

                                                    </td>

                                                </tr>

                                            )
                                        )

                            }

                        </tbody>

                    </table>

                </div>

                <div
                    className="
          flex
          justify-end
          gap-2
          mt-6
        "
                >

                    {
                        [...Array(pages)]
                            .map(
                                (
                                    _,
                                    i
                                ) => (

                                    <button
                                        key={i}
                                        onClick={() =>
                                            setPage(
                                                i + 1
                                            )
                                        }
                                        className={`
                    w-10
                    h-10
                    rounded-lg

                    ${page ===
                                                i + 1
                                                ?
                                                "bg-yellow-500 text-black"
                                                :
                                                "bg-black border border-yellow-500/20"
                                            }
                  `}
                                    >
                                        {
                                            i + 1
                                        }
                                    </button>

                                )
                            )
                    }

                </div>

            </div>

        </div>

    );

}

export default Roles;